import { createSignal, onCleanup } from "solid-js";
import { clearAllTokens } from "../lib/auth";

const IDLE_TIMEOUT = 1000 * 60 * 60; // 1 jam

export function useIdleLogout() {
  const [isIdle, setIsIdle] = createSignal(false);
  let timer: ReturnType<typeof setTimeout>;

  const resetTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setIsIdle(true);
      clearAllTokens(); // hapus token
      window.location.href = "/login";
    }, IDLE_TIMEOUT);
  };

  // pas pertama kali load
  resetTimer();

  const events = ["mousemove", "keydown", "click", "scroll"];
  events.forEach((event) => window.addEventListener(event, resetTimer));

  onCleanup(() => {
    clearTimeout(timer);
    events.forEach((event) => window.removeEventListener(event, resetTimer));
  });

  return isIdle;
}
